export default class SelfHelpCategoryRepository {
  constructor({ selfHelpCategoryService }) {
    this.selfHelpCategoryService = selfHelpCategoryService;
  }

  getCategories() {
    return this.selfHelpCategoryService.getCategories();
  }
}
